// src/pages/actives/categories/ActiveCategories.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../../../api/axios";
import Table from "../../../../components/Table";
import ActionButtons from "../../../../components/ActionButtons";
import { Plus } from "lucide-react";
import { toast } from "react-toastify";

function ActiveCategories() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = () => {
    api
      .get("/active-categories")
      .then((res) => setCategories(res.data))
      .catch(() => toast.error("Error al cargar categorías", "error"));
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow-md">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-3xl font-semibold text-gray-800">Categorías de Activos</h2>
        <Link
          to="/actives/categories/create"
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg shadow flex items-center gap-2 transition duration-300"
        >
          <Plus size={18} />
          Nueva Categoría
        </Link>
      </div>

      <Table
        columns={[
          { label: "Nombre", key: "name", width: "w-1/2" },
          { label: "Descripción", key: "description", width: "w-1/2" },
        ]}
        data={categories}
        renderActions={(category) => (
          <ActionButtons
            editUrl={`/actives/categories/edit/${category.id}`}
            onDelete={() => category.id}
          />
        )}
      />
    </div>
  );
}

export default ActiveCategories;
